export default {
  setTickets: (state, data) => {
    const { states } = state

    state.tickets.splice(0)
    
    // eslint-disable-next-line array-callback-return
    data.map(x => {
      state.tickets.push({
        id: x.id,
        code: x.code,
        name: x.name,
        plant: x.plant,
        city: x.city,
        channel: x.channel,
        direction: x.direction,
        state: x.state,
        stateText: states[x.state].text,
        stateColor: states[x.state].color,
        date: x.date,
      })
    })
  },
  setAudits: (state, data) => {
    const { statusAudit } = state

    state.audits.splice(0)

    data.map(x => {
      state.audits.push({
        id: x.id,
        type: x.type,
        typeIcon: statusAudit[x.type].icon,
        typeColor: statusAudit[x.type].color,
        title: x.title,
        description: x.description,
        date: x.date,
        userName: x.userName
      })
    })
  }
}
